import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function A() {
    const { t } = useLang('bkw');

    return (
        <div className={`bkw-A ${css['bkw-A']}`}>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1738808330965/1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1738808459033/1_M.jpg"
            />
            <div className="banner-info">
                <h1 className="banner-label">{t('A_label')}</h1>
                <p className="banner-title">
                    {t.rich('A_title', {
                        y: (tx: string) => <span className="y">{tx}</span>,
                    })}
                </p>
            </div>
            <div className="img-test">
                <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1738812012229/1_test.jpg" />
            </div>
        </div>
    );
}
